import { render, staticRenderFns } from "./SubjectList.vue?vue&type=template&id=19788877&"
import script from "./SubjectList.vue?vue&type=script&lang=js&"
export * from "./SubjectList.vue?vue&type=script&lang=js&"
import style0 from "./SubjectList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports